import React from 'react';

export default function TestPage() {
  return (
    <div style={{ padding: '20px', fontSize: '24px', color: 'green' }}>
      ✅ React 渲染成功！
    </div>
  );
}
